<script setup lang="ts">
import generateRandomKey from '@/utilities/generateRandomKey';
import { computed } from 'vue';

const props = defineProps<{
  class?: string;
  data: Array<{
    name: string;
    is_checked: boolean;
  }>;
}>();

const emit = defineEmits(['update:checkbox-list']);

function checkAll() {
  if (checkIfAllChecked.value) {
    props.data.forEach((item) => {
      item.is_checked = false;
    });
    return;
  } else {
    props.data.forEach((item) => {
      item.is_checked = true;
    });
  }
}

const checkIfAllChecked = computed(() => {
  return props.data.every((item) => item.is_checked);
});
</script>

<template>
  <div :class="props.class">
    <div class="w-full hover:bg-gray-100 px-2 py-1 flex flex-row items-center">
      <input type="checkbox" class="checkbox-list" :checked="checkIfAllChecked" @click="checkAll" />
      <h1 class="ml-2">All</h1>
    </div>
    <div v-for="(item, idx) in props.data" :key="generateRandomKey(idx)">
      <div class="flex flex-row items-center pl-8 hover:bg-gray-100 px-2 py-1">
        <input v-model="item.is_checked" type="checkbox" class="checkbox-list" @change="emit('update:checkbox-list')" />
        <h1 class="ml-2">{{ item.name }}</h1>
      </div>
    </div>
  </div>
</template>
<style scoped>
.checkbox-list {
  /* native accent color for modern browsers */
  background-color: white;
  /* size the checkbox */
  width: 16px;
  height: 16px;
  /* remove default border */
  border-color: rgb(220, 223, 230);
  outline: none;
  box-shadow: none;
  /* ensure pointer cursor */
  cursor: pointer;
}
.checkbox-list:checked {
  /* native accent color for modern browsers */
  background-color: rgb(85, 182, 145);
  /* size the checkbox */
  width: 16px;
  height: 16px;
  /* remove default border */
  border-color: rgb(85, 182, 145);
  outline: none;
  box-shadow: none;
  /* ensure pointer cursor */
  cursor: pointer;
}
.checkbox-list:hover:checked {
  background-color: rgb(85, 182, 145); /* same as base */
  border-color: rgb(85, 182, 145);
}
.checkbox-list:hover {
  background-color: white; /* same as base */
  border-color: rgb(85, 182, 145);
}
.checkbox-list:focus {
  outline: none;
  box-shadow: none;
}
</style>
